<template>
  <!-- pokazuj tylko jeśli groupBy istnieje i jest dozwolony -->
  <div v-if="currentGroupByKey" class="filter d-flex flex-column">
    <h5 class="margin-0">
      {{ t('division-into') }}
      <span class="icon-trash" @click="removeFilter()" role="button"></span>
    </h5>

    <div class="info collapse show" id="groupByFilterView">
      <p class="margin-0">
        <!-- wartości w store.groupBy to klucze tłumaczeń -->
        {{ t(store.groupBy[currentGroupByKey]) }}
      </p>
    </div>
  </div>
</template>

<script>
import { isSG } from "@/config/appVersion";

export default {
  props: {
    store: { required: true },
  },
  name: "GroupByFilterView",
  computed: {
    allowedKeys() {
      // SG: tylko pas ruchu i przekroczenie
      return isSG ? ["lane", "violation"] : Object.keys(this.store.groupBy || {});
    },
    currentGroupByKey() {
      const key = this.store?.filters?.groupBy;
      if (!key) return null;
      if (isSG && !this.allowedKeys.includes(key)) return null;
      return key;
    },
  },
  methods: {
    removeFilter() {
      this.store.removeItem("groupBy");
    },
  },
};
</script>

<style scoped>
.filter {
  width: 100%;
}

.filter h5 {
  padding: 10px 20px;
  background-color: white;
  position: relative;
  background: white url("../../assets/h-filter-bg.png") repeat-y right top;
}
.info {
  font-size: 12px;
  padding: 12px 20px;
  border-bottom: 1px solid #bbbbbb;
}
.info p {
  font-size: 12px;
}
.icon-trash {
  background: url("../../assets/icons/trash.svg") no-repeat left top;
  width: 15px;
  height: 17px;
  position: absolute;
  cursor: pointer;
  top: 11px;
  right: 10px;
}
.icon-collapse {
  background: url("../../assets/icons/zwin.png") no-repeat left top;
  width: 19px;
  height: 19px;
  position: absolute;
  cursor: pointer;
  right: 20px;
}
.collapsed.icon-collapse {
  background: url("../../assets/icons/rozwin.png") no-repeat left top;
}
</style>
